var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import createStyle from './createStyle';
import Label from '../label/index.react';

var Checkbox = function Checkbox(_a) {
  var className = _a.className,
      checked = _a.checked,
      disabled = _a.disabled,
      _b = _a.onChange,
      onChange = _b === void 0 ? function () {} : _b,
      label = _a.label,
      _c = _a.theme,
      theme = _c === void 0 ? 'light' : _c,
      _d = _a.status,
      status = _d === void 0 ? 'normal' : _d,
      props = __rest(_a, ["className", "checked", "disabled", "onChange", "label", "theme", "status"]);

  var finalClassName = createStyle({
    className: className,
    status: status,
    disabled: disabled
  });

  var handleChange = function handleChange(_a) {
    var target = _a.target;
    return onChange(target.checked);
  };

  var labelTestId = props['data-test-id'] ? props['data-test-id'] + "-label" : '';
  return React.createElement(Label, {
    disabled: disabled,
    theme: theme,
    className: finalClassName,
    "data-test-id": labelTestId
  }, React.createElement("input", __assign({
    type: "checkbox",
    checked: checked,
    onChange: handleChange,
    disabled: disabled
  }, props)), React.createElement("span", {
    className: "checkmark"
  }), label && React.createElement("span", {
    className: "label"
  }, label));
};

export default Checkbox;